import { ActivityView } from 'src/app/views/master-views/app.view/app.view.component';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'wm-generate-application-number-activity-input',
    templateUrl: './generate-application-number-activity-input.component.html',
    styleUrls: ['./generate-application-number-activity-input.component.css'],
    standalone: false
})
export class GenerateApplicationNumberActivityInputComponent
  extends ActivityView
  implements OnInit {
  constructor() {
    super();
  }

  ngOnInit() {}
}
